// C.1 — каркас нейтральной фракции (туториал + общие карты).
//
// Подключение реализованных способностей:
//   - Герой «Лидер улицы»: аура (1-я линия +1/0/0, 2-я +0/1/1) + активка
//     (3 урона выбранному вражескому юниту, 1× за матч).
//   - Юниты: Уличный шаман, Старик с ИЭД, Контрабандист дронов.
//   - Действие: Прайс-лист (draw 2).
//
// Аура Лидера пересчитывается при изменении состава поля — через
// registerUnitSummonedExtraHandler / registerOnUnitDiedExtraHandler.

import { recomputeStreetLeaderAura } from '../../keywords/street_leader_aura.js';
import {
  registerUnitSummonedExtraHandler,
  registerOnUnitDiedExtraHandler
} from '../deus/hooks.js';

import {
  liderUlicyActive,
  liderUlicyActiveAvailable,
  getLiderUlicyActiveTargets,
  HERO_ID as STREET_LEADER_HERO_ID
} from './lider_ulicy.js';

import './units.js';
import {
  PRICE_LIST_ID,
  actionNeedsTarget as neutralActionNeedsTarget,
  getActionTargets as neutralGetActionTargets,
  resolveAction as neutralResolveAction
} from './actions.js';

// Реэкспорт для UI.
export {
  liderUlicyActive,
  liderUlicyActiveAvailable,
  getLiderUlicyActiveTargets,
  STREET_LEADER_HERO_ID,
  PRICE_LIST_ID,
  neutralActionNeedsTarget,
  neutralGetActionTargets,
  neutralResolveAction
};

// Аура Лидера улицы — пересчёт при изменении состава поля.
registerUnitSummonedExtraHandler((state /* , ownerIdx, card */) => {
  recomputeStreetLeaderAura(state);
});
registerOnUnitDiedExtraHandler((state /* , payload */) => {
  recomputeStreetLeaderAura(state);
});
